import React, { useState, useEffect, useContext } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import api, { BASE_URL } from "../../Utils/api";
import { GlobalContext } from "../../Utils/GlobalContext";
import { Salvar, Cancelar } from "../Generals/buttons";

// Seleção de usuários para notificação de um Tipo de Agendamento — extraído de
// TiposAgendamentoModal.js para poder ser aberto sozinho (ex.: ação direta na
// grid de TiposAgendamento.js), sem precisar renderizar o modal de edição por
// baixo.
const UsuariosNotificacaoModal = ({ show, handleClose, agendamentoId }) => {
  const { globalData } = useContext(GlobalContext);
  const entidadeID = globalData?.entidade_id || localStorage.getItem("entidade_id");

  const [listaUsuarios, setListaUsuarios] = useState([]);
  const [usuariosNotificacao, setUsuariosNotificacao] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [listaUsuariosFiltrada, setListaUsuariosFiltrada] = useState([]);

  useEffect(() => {
    if (show && agendamentoId) {
      fetchUsuariosNotificacao(agendamentoId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, agendamentoId]);

  // Carrega todos os usuários disponíveis e os que já estão configurados para o tipo de agendamento
  const fetchUsuariosNotificacao = async (tipoAgendamentoId) => {
    try {
      const response = await api.get(
        `${BASE_URL}/api/usuarios/ListarUsuariosNotificacao/${entidadeID}`
      );
      setListaUsuarios(response.data.data);
      setListaUsuariosFiltrada(response.data.data);

      try {
        const configuradosResponse = await api.get(
          `${BASE_URL}/api/tiposAgendamentos/ListarUsuariosNotificacaoConfigurados/${tipoAgendamentoId}`
        );
        const configurados = configuradosResponse.data.data.map((u) => u.id_usuario);
        setUsuariosNotificacao(configurados);
      } catch (configError) {
        console.error("Erro ao buscar usuários configurados:", configError);
        setUsuariosNotificacao([]);
      }
    } catch (error) {
      console.error("Erro ao buscar usuários:", error);
      setListaUsuarios([]);
      setListaUsuariosFiltrada([]);
    }
  };

  const handleSearchChange = (term) => {
    setSearchTerm(term);
    if (term) {
      const filtered = listaUsuarios.filter((usuario) =>
        usuario.nome.toLowerCase().includes(term.toLowerCase())
      );
      setListaUsuariosFiltrada(filtered);
    } else {
      setListaUsuariosFiltrada(listaUsuarios);
    }
  };

  const handleUserClick = (userId) => {
    setUsuariosNotificacao((prevSelected) => {
      if (prevSelected.includes(userId)) {
        return prevSelected.filter((id) => id !== userId);
      }
      return [...prevSelected, userId];
    });
    setSearchTerm("");
    setListaUsuariosFiltrada(listaUsuarios);
  };

  const handleSaveUsuarios = async () => {
    try {
      await api.put(
        `${BASE_URL}/api/tiposAgendamentos/EditarUsuariosNotificacao/${agendamentoId}`,
        { usuarios: usuariosNotificacao }
      );
      handleClose();
    } catch (error) {
      console.error("Erro ao salvar usuários de notificação:", error);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} dialogClassName="modal-dialog-top">
      <Modal.Header closeButton style={{ background: "var(--surface-sunken)", borderColor: "var(--border-default)", paddingBottom: 12 }}>
        <Modal.Title style={{ fontSize: "1rem", fontWeight: 600, color: "var(--text-body)" }}>
          Selecionar Usuários para Notificação
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ background: "var(--surface-card)", color: "var(--text-body)" }}>
        <Form.Group controlId="searchUsuarios">
          <Form.Label>Pesquisar Usuários</Form.Label>
          <Form.Control
            type="text"
            value={searchTerm}
            placeholder="Digite para pesquisar..."
            onChange={(e) => handleSearchChange(e.target.value)}
          />
        </Form.Group>
        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
          {listaUsuariosFiltrada.map((usuario) => (
            <div
              key={usuario.id}
              onClick={() => handleUserClick(usuario.id)}
              className={`user-item ${usuariosNotificacao.includes(usuario.id) ? "selected" : ""}`}
              style={{
                padding: "10px",
                margin: "5px 0",
                border: "1px solid var(--border-default)",
                borderRadius: "var(--radius, 6px)",
                cursor: "pointer",
                background: usuariosNotificacao.includes(usuario.id)
                  ? "var(--accent)"
                  : "var(--surface-card)",
                color: usuariosNotificacao.includes(usuario.id)
                  ? "#fff"
                  : "var(--text-body)",
              }}
            >
              {usuario.nome}
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer-padrao">
        <div className="modal-footer-acoes-esquerda" />
        <div className="modal-footer-acoes-direita">
          <Cancelar onClick={handleClose} />
          <Salvar onClick={handleSaveUsuarios} title="Salvar Seleção" />
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default UsuariosNotificacaoModal;
